(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kv-media-badge"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kv-media-badge')) {
    customElements.define('kv-media-badge', class extends HTMLElement {
      connectedCallback() {
        if (this.dismissHandler) return;
        this.dismissHandler = () => {
          this.hidden = true;
        };
        this.querySelector('button')?.addEventListener('click', this.dismissHandler);
        const label = this.querySelector('.kv-media-badge__text');
        if (label && typeof ResizeObserver !== 'undefined') {
          this.labelObserver = new ResizeObserver(() => {
            if (this.hidden) return;
            const height = Math.max(30, label.getBoundingClientRect().height);
            this.style.setProperty('--badge-height', `${height}px`);
          });
          this.labelObserver.observe(label);
        }
      }

      disconnectedCallback() {
        this.querySelector('button')?.removeEventListener('click', this.dismissHandler);
        this.dismissHandler = null;
        this.labelObserver?.disconnect();
        this.labelObserver = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
